import { gql } from "@apollo/client";

/** Admin reporting: buyer pharmacy picker (sorted by legal name). */
export const PHARMACIES_FOR_REPORTS_SELECT = gql`
  query PharmaciesForReportsSelect {
    findManyPharmacy(orderBy: [{ legalName: asc }]) {
      id
      legalName
    }
  }
`;

export const TOP_BUYERS_BY_NDC = gql`
  query TopBuyersByNdc(
    $ndc: String!
    $limit: Int
    $orderCreatedFrom: String
    $orderCreatedTo: String
  ) {
    topBuyersByNdc(
      ndc: $ndc
      limit: $limit
      orderCreatedFrom: $orderCreatedFrom
      orderCreatedTo: $orderCreatedTo
    ) {
      buyerPharmacyId
      buyerPharmacyName
      buyerPharmacyEmail
      buyerUserEmail
      lastOrderDate
      minPrice
      maxPrice
      orderCount
      totalSpent
    }
  }
`;

export const TOP_PRODUCTS_FOR_BUYER_PHARMACY = gql`
  query TopProductsForBuyerPharmacy(
    $buyerPharmacyId: Int!
    $limit: Int
    $orderCreatedFrom: String
    $orderCreatedTo: String
  ) {
    topProductsForBuyerPharmacy(
      buyerPharmacyId: $buyerPharmacyId
      limit: $limit
      orderCreatedFrom: $orderCreatedFrom
      orderCreatedTo: $orderCreatedTo
    ) {
      productId
      ndc
      drugName
      orderCount
      totalQuantity
      totalSpent
    }
  }
`;

export const CONFIRMED_NOT_SHIPPED_ORDERS = gql`
  query ConfirmedNotShippedOrders(
    $limit: Int
    $orderCreatedFrom: String
    $orderCreatedTo: String
  ) {
    confirmedNotShippedOrders(
      limit: $limit
      orderCreatedFrom: $orderCreatedFrom
      orderCreatedTo: $orderCreatedTo
    ) {
      orderId
      orderNumber
      buyerPharmacyName
      sellerPharmacyName
      orderAmount
      createdAt
      shippingStatusLabel
    }
  }
`;

export const SHORTAGE_PRODUCTS = gql`
  query ShortageProducts(
    $limit: Int
    $buyerPharmacyId: Int
    $orderCreatedFrom: String
    $orderCreatedTo: String
  ) {
    shortageProducts(
      limit: $limit
      buyerPharmacyId: $buyerPharmacyId
      orderCreatedFrom: $orderCreatedFrom
      orderCreatedTo: $orderCreatedTo
    ) {
      ndc
      drugName
      strengths
      orderCount
      totalQuantity
      totalSpent
      minPricePaid
      maxPricePaid
    }
  }
`;
